import { useAuthStore } from '@/stores/authStore'
import { clearToken, ensureToken, safeLogout } from '@/lib/sso'
import { Button } from '@/components/shadcn/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/shadcn/card'

export default function SSOTestPage() {
  const { user, token, isAuthenticated } = useAuthStore()

  const handleLogout = () => {
    safeLogout()
  }

  const handleForceLogin = () => {
    ensureToken()
  }

  return (
    <div className="container mx-auto p-6 space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>SSO 测试页面</CardTitle>
          <CardDescription>
            此页面用于测试SSO单点登录功能
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <h3 className="font-semibold mb-2">认证状态</h3>
            <p>已认证: {isAuthenticated ? '是' : '否'}</p>
            <p>Token: {token ? '已设置' : '未设置'}</p>
          </div>

          {user && (
            <div>
              <h3 className="font-semibold mb-2">用户信息</h3>
              <p>姓名: {user.name}</p>
              <p>邮箱: {user.email}</p>
              <p>计划: {user.plan}</p>
            </div>
          )}

          <div className="flex space-x-4">
            <Button onClick={handleLogout} variant="outline">
              登出
            </Button>
            <Button onClick={handleForceLogin} variant="default">
              强制登录
            </Button>
          </div>

          <div className="text-sm text-muted-foreground">
            <p>• 点击"登出"会清除本地token并跳转到A站</p>
            <p>• 点击"强制登录"会检查token有效性，无效则跳转到A站</p>
            <p>• 如果URL中包含access_token，会自动提取并保存</p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
